import type { HTTPService } from "@soft-db/http";

export type ArchiveTaskJob = {
	id: string;
	createdTime: string;
	scheduledTime: string;
	retryCount: number;
};

export type ArchiveTaskState =
	| "PACK_RECORDS"
	| "PACK_COMMENTS"
	| "PACK_EVENTS"
	| "PACK_CONFIGS"
	| "DISCOVER_EVENTS_FILES"
	| "BUNDLE"
	| "VALIDATE";
export type ArchiveTaskProgress = {
	startTime: string;
	endTime: string;
	finished: boolean;
	bundleAvailable: boolean;
	currentTask: {
		type: ArchiveTaskState;
		progress: number;
	};
	progress: number;
	tasks: ArchiveTaskState[];
};
export type ArchiveTask = {
	id: string;
	startTime: string;
	endTime: string;
	job: ArchiveTaskJob | null;
	progress: ArchiveTaskProgress | null;
};

export type ArchiveTaskResult = {
	id: string;
	url: string;
};

export class ArchiveApi {
	constructor(private _http: HTTPService) {}

	async getAllTasks(site: string) {
		return await this._http.get<ArchiveTask[]>(`/sites/${site}/archives/tasks`);
	}

	async createTask(site: string, startTime: Date, endTime: Date) {
		return await this._http.post<ArchiveTaskJob>(`/sites/${site}/archives/tasks`, {
			startTime,
			endTime,
		});
	}

	async getTaskProgress(site: string, task: string) {
		return await this._http.get<ArchiveTask>(`/sites/${site}/archives/tasks/${task}/progress`);
	}

	async getTaskResult(site: string, task: string, filename?: string) {
		return await this._http.get<ArchiveTaskResult>(`/sites/${site}/archives/tasks/${task}`, {
			params: { filename },
		});
	}
}
